export default __webpack_public_path__ + "static/media/EbillSaving.1aa6c576.svg";